export interface IataAirline {
  code: string;
  name: string;
}

/**
 * Source: https://github.com/npow/airline-codes (airlines.json), filtered to active carriers
 * with a valid 2-character IATA code. Cargo-division duplicates, GDS/non-airline, and
 * flight-simulation-only entries removed.
 */
export const IATA_AIRLINES: IataAirline[] = [
  { code: "01", name: "Bobb Air Freight" },
  { code: "0B", name: "Blue Air" },
  { code: "0D", name: "Darwin Airline" },
  { code: "0G", name: "Global Airlines" },
  { code: "0M", name: "All America MX" },
  { code: "0P", name: "All America BOPY" },
  { code: "0X", name: "Copenhagen Express" },
  { code: "0Y", name: "All America CO" },
  { code: "11", name: "TUIfly (X3)" },
  { code: "12", name: "12 North" },
  { code: "1C", name: "OneChina" },
  { code: "1E", name: "TransRussiaAirlines" },
  { code: "1F", name: "CB Airways UK ( Interliging Flights )" },
  { code: "1I", name: "NetJets" },
  { code: "1K", name: "BudgetAir" },
  { code: "1R", name: "All America CL" },
  { code: "1T", name: "1Time Airline" },
  { code: "1X", name: "Island Express Air" },
  { code: "1Y", name: "All America BR" },
  { code: "20", name: "Air Salone" },
  { code: "24", name: "Euro Jet" },
  { code: "2A", name: "Deutsche Bahn" },
  { code: "2B", name: "Aerocondor" },
  { code: "2D", name: "Aero VIP (2D)" },
  { code: "2F", name: "Frontier Flying Service" },
  { code: "2I", name: "Star Peru (2I)" },
  { code: "2J", name: "Air Burkina" },
  { code: "2K", name: "Aerolineas Galapagos (Aerogal)" },
  { code: "2L", name: "Helvetic Airways" },
  { code: "2M", name: "Moldavian Airlines" },
  { code: "2N", name: "NextJet" },
  { code: "2O", name: "Air Salone" },
  { code: "2P", name: "Air Philippines" },
  { code: "2Q", name: "Air Cargo Carriers" },
  { code: "2R", name: "All America AR" },
  { code: "2S", name: "Air Carnival" },
  { code: "2T", name: "Haiti Ambassador Airlines" },
  { code: "2U", name: "Air Guinee Express" },
  { code: "2W", name: "Welcome Air" },
  { code: "2X", name: "Regionalia Uruguay" },
  { code: "3B", name: "JobAir" },
  { code: "3E", name: "Air Choice One" },
  { code: "3F", name: "Fly Colombia ( Interliging Flights )" },
  { code: "3I", name: "Air Comet Chile" },
  { code: "3K", name: "Jetstar Asia Airways" },
  { code: "3L", name: "Intersky" },
  { code: "3M", name: "Silver Airways (3M)" },
  { code: "3O", name: "Air Arabia Maroc" },
  { code: "3P", name: "Tiara Air" },
  { code: "3Q", name: "Yunnan Airlines" },
  { code: "3R", name: "Moskovia Airlines" },
  { code: "3S", name: "Air Antilles Express" },
  { code: "3T", name: "Turan Air" },
  { code: "3U", name: "Sichuan Airlines" },
  { code: "3W", name: "Malawian Airlines" },
  { code: "4A", name: "Air Kiribati" },
  { code: "4B", name: "Boutique Air (Priv)" },
  { code: "4C", name: "Aires" },
  { code: "4D", name: "Air Sinai" },
  { code: "4G", name: "Gazpromavia" },
  { code: "4H", name: "United Airways" },
  { code: "4K", name: "Askari Aviation" },
  { code: "4L", name: "Euroline" },
  { code: "4M", name: "LAN Argentina" },
  { code: "4N", name: "Air North Charter - Canada" },
  { code: "4O", name: "Interjet (ABC Aerolineas)" },
  { code: "4P", name: "Business Aviation" },
  { code: "4Q", name: "Safi Airlines" },
  { code: "4R", name: "Hamburg International" },
  { code: "4S", name: "Vuola Italia" },
  { code: "4T", name: "Belair Airlines" },
  { code: "4U", name: "Germanwings" },
  { code: "4X", name: "Red Jet Mexico" },
  { code: "4Z", name: "Airlink (SAA)" },
  { code: "5B", name: "Bassaka airlines" },
  { code: "5C", name: "CAL Cargo Air Lines" },
  { code: "5D", name: "Aerolitoral" },
  { code: "5E", name: "SGA Airlines" },
  { code: "5G", name: "Skyservice Airlines" },
  { code: "5H", name: "Fly540" },
  { code: "5J", name: "Cebu Pacific" },
  { code: "5K", name: "Hi Fly (5K)" },
  { code: "5L", name: "Aerosur" },
  { code: "5M", name: "Sibaviatrans" },
  { code: "5N", name: "Aeroflot-Nord" },
  { code: "5P", name: "Pal airlines" },
  { code: "5Q", name: "BQB Lineas Aereas" },
  { code: "5T", name: "Canadian North" },
  { code: "5W", name: "Astraeus" },
  { code: "5Y", name: "Atlas Air" },
  { code: "5Z", name: "VivaColombia" },
  { code: "69", name: "Royal European Airlines" },
  { code: "6A", name: "Consorcio Aviaxsa" },
  { code: "6B", name: "TUIfly Nordic" },
  { code: "6C", name: "Vuela Cuba" },
  { code: "6D", name: "Pelita" },
  { code: "6E", name: "IndiGo Airlines" },
  { code: "6F", name: "MAT Airways" },
  { code: "6G", name: "Air Wales" },
  { code: "6H", name: "Israir" },
  { code: "6I", name: "Fly 6ix" },
  { code: "6J", name: "Skynet Asia Airways" },
  { code: "6K", name: "Asian Spirit" },
  { code: "6P", name: "Gryphon Airlines" },
  { code: "6R", name: "Alrosa Mirny Air Enterprise" },
  { code: "6T", name: "Air Mandalay" },
  { code: "6U", name: "Air Cargo Germany" },
  { code: "6V", name: "Via Conectia Airlines" },
  { code: "6W", name: "Saratov Aviation Division" },
  { code: "6Y", name: "SmartLynx Airlines" },
  { code: "76", name: "Southjet" },
  { code: "77", name: "Southjet connect" },
  { code: "78", name: "Southjet cargo" },
  { code: "7B", name: "Krasnojarsky Airlines" },
  { code: "7C", name: "Jeju Air" },
  { code: "7E", name: "Aeroline GmbH" },
  { code: "7F", name: "First Air" },
  { code: "7G", name: "Star Flyer" },
  { code: "7H", name: "Era Alaska" },
  { code: "7I", name: "Insel Air (7I/INC) (Priv)" },
  { code: "7J", name: "Tajik Air" },
  { code: "7K", name: "Kogalymavia Air Company" },
  { code: "7L", name: "Sun D'Or" },
  { code: "7M", name: "Mongolian International Air Lines " },
  { code: "7O", name: "All Colombia" },
  { code: "7P", name: "Metro Batavia" },
  { code: "7Q", name: "Pan Am World Airways Dominicana" },
  { code: "7R", name: "Svyaz Rossiya" },
  { code: "7T", name: "Air Glaciers" },
  { code: "7W", name: "Wayraper" },
  { code: "7Y", name: "Med Airways" },
  { code: "7Z", name: "Halcyonair" },
  { code: "88", name: "All Australia" },
  { code: "8A", name: "Atlas Blue" },
  { code: "8B", name: "BusinessAir" },
  { code: "8D", name: "Astair" },
  { code: "8E", name: "Bering Air" },
  { code: "8F", name: "STP Airways" },
  { code: "8H", name: "Heli France" },
  { code: "8I", name: "Myway Airlines" },
  { code: "8J", name: "Jet4You" },
  { code: "8K", name: "Voestar" },
  { code: "8L", name: "Cargo Plus Aviation" },
  { code: "8N", name: "Barents AirLink" },
  { code: "8O", name: "West Coast Air" },
  { code: "8P", name: "Pacific Coastal Airline" },
  { code: "8R", name: "TRIP Linhas A" },
  { code: "8T", name: "Air Tindi" },
  { code: "8U", name: "Afriqiyah Airways" },
  { code: "8V", name: "Astral Aviation" },
  { code: "8Z", name: "Wizz Air Hungary" },
  { code: "99", name: "Ciao Air" },
  { code: "9A", name: "All Africa" },
  { code: "9C", name: "China SSS" },
  { code: "9E", name: "Pinnacle Airlines" },
  { code: "9H", name: "MDLR Airlines" },
  { code: "9I", name: "International Europe" },
  { code: "9J", name: "Regionalia Chile" },
  { code: "9K", name: "Cape Air" },
  { code: "9L", name: "Colgan Air" },
  { code: "9N", name: "Regional Air Iceland" },
  { code: "9Q", name: "PB Air" },
  { code: "9R", name: "SATENA" },
  { code: "9S", name: "Spring Airlines" },
  { code: "9T", name: "Transwest Air" },
  { code: "9U", name: "Air Moldova" },
  { code: "9V", name: "Volotea Costa Rica" },
  { code: "9W", name: "Jet Airways" },
  { code: "9X", name: "Regionalia Venezuela" },
  { code: "9Y", name: "Air Kazakhstan" },
  { code: "A1", name: "Atifly" },
  { code: "A2", name: "All America" },
  { code: "A3", name: "Aegean Airlines" },
  { code: "A4", name: "Southern Winds Airlines" },
  { code: "A5", name: "Airlinair" },
  { code: "A6", name: "Air Alps Aviation (A6)" },
  { code: "A7", name: "Air Plus Comet" },
  { code: "A9", name: "Georgian Airways" },
  { code: "AA", name: "American Airlines" },
  { code: "AB", name: "Air Berlin" },
  { code: "AC", name: "Air Canada" },
  { code: "AD", name: "Azul" },
  { code: "AE", name: "Mandarin Airlines" },
  { code: "AF", name: "Air France" },
  { code: "AG", name: "All America US" },
  { code: "AH", name: "Air Algerie" },
  { code: "AI", name: "Air India Limited" },
  { code: "AJ", name: "Aero Contractors" },
  { code: "AK", name: "AirAsia" },
  { code: "AL", name: "Skywalk Airlines" },
  { code: "AM", name: "AeroMéxico" },
  { code: "AN", name: "Ansett Australia" },
  { code: "AO", name: "Avianova (Russia)" },
  { code: "AP", name: "Air One" },
  { code: "AQ", name: "Aloha Airlines" },
  { code: "AR", name: "Aerolineas Argentinas" },
  { code: "AS", name: "Alaska Airlines" },
  { code: "AT", name: "Royal Air Maroc" },
  { code: "AU", name: "Austral Lineas Aereas" },
  { code: "AV", name: "Avianca - Aerovias Nacionales de Colombia" },
  { code: "AW", name: "Asian Wings Airways" },
  { code: "AX", name: "Trans States Airlines" },
  { code: "AY", name: "Finnair" },
  { code: "AZ", name: "ITA Airways" },
  { code: "B0", name: "Aws express" },
  { code: "B1", name: "Baltic Air lines" },
  { code: "B2", name: "Belavia Belarusian Airlines" },
  { code: "B4", name: "Flyglobespan" },
  { code: "B5", name: "Flightline" },
  { code: "B6", name: "JetBlue Airways" },
  { code: "B7", name: "Uni Air" },
  { code: "B8", name: "Eritrean Airlines" },
  { code: "BA", name: "British Airways" },
  { code: "BB", name: "Seaborne Airlines" },
  { code: "BC", name: "Skymark Airlines" },
  { code: "BD", name: "bmi" },
  { code: "BE", name: "Flybe" },
  { code: "BF", name: "Aero-Service" },
  { code: "BG", name: "Biman Bangladesh Airlines" },
  { code: "BH", name: "Hawkair" },
  { code: "BI", name: "Royal Brunei Airlines" },
  { code: "BJ", name: "Nouvel Air Tunisie" },
  { code: "BK", name: "Potomac Air" },
  { code: "BL", name: "Jetstar Pacific" },
  { code: "BM", name: "Air Sicilia" },
  { code: "BN", name: "Horizon Airlines" },
  { code: "BP", name: "Air Botswana" },
  { code: "BQ", name: "Buquebus Líneas Aéreas" },
  { code: "BR", name: "EVA Air" },
  { code: "BT", name: "Air Baltic" },
  { code: "BU", name: "Baikotovitchestrian Airlines " },
  { code: "BV", name: "Blue Panorama Airlines" },
  { code: "BW", name: "Caribbean Airlines" },
  { code: "BX", name: "Air Busan" },
  { code: "BY", name: "Thomsonfly" },
  { code: "BZ", name: "Black Stallion Airways" },
  { code: "C0", name: "Centralwings" },
  { code: "C1", name: "CanXpress" },
  { code: "C2", name: "CanXplorer" },
  { code: "C4", name: "LionXpress" },
  { code: "C5", name: "CommutAir" },
  { code: "C7", name: "Sky Wing Pacific" },
  { code: "C9", name: "Cirrus Airlines" },
  { code: "CA", name: "Air China" },
  { code: "CB", name: "CCML Airlines" },
  { code: "CC", name: "Air Atlanta Icelandic" },
  { code: "CD", name: "Air India Regional" },
  { code: "CE", name: "Nationwide Airlines" },
  { code: "CF", name: "City Airline" },
  { code: "CG", name: "Airlines PNG" },
  { code: "CH", name: "Bemidji Airlines" },
  { code: "CI", name: "China Airlines" },
  { code: "CJ", name: "BA CityFlyer" },
  { code: "CL", name: "Lufthansa CityLine" },
  { code: "CM", name: "Copa Airlines" },
  { code: "CN", name: "Canadian National Airways" },
  { code: "CQ", name: "SOCHI AIR" },
  { code: "CS", name: "Continental Micronesia" },
  { code: "CT", name: "Alitalia Cityliner" },
  { code: "CU", name: "Cubana de Aviación" },
  { code: "CV", name: "Air Chathams" },
  { code: "CW", name: "Air Marshall Islands" },
  { code: "CX", name: "Cathay Pacific" },
  { code: "CY", name: "Cyprus Airways" },
  { code: "CZ", name: "China Southern Airlines" },
  { code: "D1", name: "Domenican Airlines" },
  { code: "D2", name: "Severstal Air Company" },
  { code: "D3", name: "Daallo Airlines" },
  { code: "D6", name: "Interair South Africa" },
  { code: "D7", name: "AirAsia X" },
  { code: "D8", name: "Djibouti Airlines" },
  { code: "D9", name: "Aeroflot-Don" },
  { code: "DA", name: "Dana Air" },
  { code: "DB", name: "Brit Air" },
  { code: "DC", name: "Golden Air" },
  { code: "DD", name: "Nok Air" },
  { code: "DE", name: "Condor Flugdienst" },
  { code: "DF", name: "Michael Airlines" },
  { code: "DG", name: "South East Asian Airlines" },
  { code: "DH", name: "Dennis Sky" },
  { code: "DI", name: "dba" },
  { code: "DK", name: "Eastland Air" },
  { code: "DL", name: "Delta Air Lines" },
  { code: "DM", name: "Maersk" },
  { code: "DN", name: "Senegal Airlines" },
  { code: "DO", name: "Dominicana de Aviaci" },
  { code: "DP", name: "First Choice Airways" },
  { code: "DQ", name: "Coastal Air" },
  { code: "DR", name: "Air Mediterranee" },
  { code: "DS", name: "EasyJet (DS)" },
  { code: "DT", name: "TAAG Angola Airlines" },
  { code: "DU", name: "Norwegian Long Haul AS" },
  { code: "DV", name: "Scat Air" },
  { code: "DX", name: "DAT Danish Air Transport" },
  { code: "DY", name: "Norwegian Air Shuttle" },
  { code: "DZ", name: "Starline.kz" },
  { code: "E1", name: "Usa Sky Cargo" },
  { code: "E2", name: "Eagle Atlantic Airlines" },
  { code: "E3", name: "Domodedovo Airlines" },
  { code: "E4", name: "Elysian Airlines" },
  { code: "E5", name: "Air Arabia Egypt" },
  { code: "E8", name: "City Airways" },
  { code: "E9", name: "Compagnie Africaine d'Aviation" },
  { code: "EA", name: "European Air Express" },
  { code: "EC", name: "Avialeasing Aviation Company" },
  { code: "ED", name: "Airblue" },
  { code: "EE", name: "Nordica" },
  { code: "EF", name: "Far Eastern Air Transport" },
  { code: "EG", name: "Japan Asia Airways" },
  { code: "EI", name: "Aer Lingus" },
  { code: "EJ", name: "New England Airlines" },
  { code: "EK", name: "Emirates" },
  { code: "EL", name: "Air Nippon" },
  { code: "EM", name: "Aero Benin" },
  { code: "EN", name: "Air Dolomiti" },
  { code: "EO", name: "Express One International" },
  { code: "EP", name: "Iran Aseman Airlines" },
  { code: "EQ", name: "TAME" },
  { code: "ER", name: "Fly Europa" },
  { code: "ES", name: "EuropeSky" },
  { code: "ET", name: "Ethiopian Airlines" },
  { code: "EU", name: "Empresa Ecuatoriana De Aviacion" },
  { code: "EV", name: "Atlantic Southeast Airlines" },
  { code: "EW", name: "Eurowings" },
  { code: "EX", name: "Europe Jet" },
  { code: "EY", name: "Etihad Airways" },
  { code: "EZ", name: "Evergreen International Airlines" },
  { code: "F1", name: "Fly Brasil" },
  { code: "F5", name: "Fly One" },
  { code: "F7", name: "Flybaboo" },
  { code: "F8", name: "Air2there" },
  { code: "F9", name: "Frontier Airlines" },
  { code: "FA", name: "Epic Holiday" },
  { code: "FB", name: "Bulgaria Air" },
  { code: "FC", name: "Finncomm Airlines" },
  { code: "FD", name: "Thai AirAsia" },
  { code: "FF", name: "Fly France" },
  { code: "FG", name: "Ariana Afghan Airlines" },
  { code: "FH", name: "FlyHigh Airlines Ireland (FH)" },
  { code: "FI", name: "Icelandair" },
  { code: "FJ", name: "Air Pacific" },
  { code: "FK", name: "Africa West" },
  { code: "FL", name: "AirTran Airways" },
  { code: "FM", name: "Shanghai Airlines" },
  { code: "FN", name: "Regional Airlines" },
  { code: "FO", name: "Airlines Of Tasmania" },
  { code: "FP", name: "Freedom Air" },
  { code: "FQ", name: "Thomas Cook Airlines" },
  { code: "FR", name: "Ryanair" },
  { code: "FS", name: "Servicios de Transportes A" },
  { code: "FT", name: "Siem Reap Airways" },
  { code: "FU", name: "Felix Airways" },
  { code: "FV", name: "Rossiya-Russian Airlines" },
  { code: "FW", name: "Ibex Airlines" },
  { code: "FX", name: "FOX Linhas Aereas" },
  { code: "FY", name: "Firefly" },
  { code: "FZ", name: "Fly Dubai" },
  { code: "G0", name: "Ghana International Airlines" },
  { code: "G1", name: "Indya Airline Group" },
  { code: "G3", name: "Gol Transportes Aéreos" },
  { code: "G4", name: "Allegiant Air" },
  { code: "G5", name: "Huaxia" },
  { code: "G6", name: "Air Volga" },
  { code: "G7", name: "GoJet Airlines" },
  { code: "G8", name: "Go Air" },
  { code: "G9", name: "Air Arabia" },
  { code: "GA", name: "Garuda Indonesia" },
  { code: "GB", name: "BRAZIL AIR" },
  { code: "GE", name: "TransAsia Airways" },
  { code: "GF", name: "Gulf Air Bahrain" },
  { code: "GG", name: "Air Guyane" },
  { code: "GH", name: "Globus" },
  { code: "GI", name: "Itek Air" },
  { code: "GJ", name: "Eurofly Service" },
  { code: "GK", name: "Genesis" },
  { code: "GL", name: "Air Greenland" },
  { code: "GM", name: "German International Air Lines" },
  { code: "GN", name: "GNB Linhas Aereas" },
  { code: "GO", name: "Kuzu Airlines Cargo" },
  { code: "GP", name: "Gadair European Airlines" },
  { code: "GQ", name: "Sky Express" },
  { code: "GR", name: "Aurigny Air Services" },
  { code: "GS", name: "Air Foyle" },
  { code: "GT", name: "GB Airways" },
  { code: "GV", name: "Aero Flight" },
  { code: "GW", name: "Kuban Airlines" },
  { code: "GX", name: "GermanXL" },
  { code: "GY", name: "Gabon Airlines" },
  { code: "GZ", name: "Air Rarotonga" },
  { code: "H1", name: "Hankook Air US" },
  { code: "H2", name: "Sky Airline" },
  { code: "H3", name: "Harbour Air (Priv)" },
  { code: "H5", name: "I-Fly" },
  { code: "H6", name: "Hageland Aviation Services" },
  { code: "H7", name: "Eagle Air" },
  { code: "H8", name: "Dalavia" },
  { code: "H9", name: "PEGASUS AIRLINES-" },
  { code: "HA", name: "Hawaiian Airlines" },
  { code: "HC", name: "Himalayan Airlines" },
  { code: "HD", name: "Hokkaido International Airlines" },
  { code: "HE", name: "Luftfahrtgesellschaft Walter" },
  { code: "HF", name: "Hapagfly" },
  { code: "HG", name: "Niki" },
  { code: "HH", name: "Air Hamburg (AHO)" },
  { code: "HI", name: "Papillon Grand Canyon Helicopters" },
  { code: "HK", name: "Yangon Airways" },
  { code: "HM", name: "Air Seychelles" },
  { code: "HN", name: "Hankook Airline" },
  { code: "HO", name: "Juneyao Airlines" },
  { code: "HP", name: "America West Airlines" },
  { code: "HR", name: "China United Airlines" },
  { code: "HT", name: "Hellenic Imperial Airways" },
  { code: "HU", name: "Hainan Airlines" },
  { code: "HV", name: "Transavia Holland" },
  { code: "HW", name: "Hello" },
  { code: "HX", name: "Hong Kong Airlines" },
  { code: "HY", name: "Uzbekistan Airways" },
  { code: "HZ", name: "Sat Airlines" },
  { code: "I2", name: "Iberia Express" },
  { code: "I3", name: "ATA Airlines (Iran)" },
  { code: "I4", name: "International AirLink" },
  { code: "I5", name: "Indonesia Sky" },
  { code: "I6", name: "MexicanaLink" },
  { code: "I7", name: "Paramount Airways" },
  { code: "I8", name: "IzAvia" },
  { code: "IA", name: "Iraqi Airways" },
  { code: "IB", name: "Iberia Airlines" },
  { code: "IC", name: "Indian Airlines" },
  { code: "ID", name: "Interlink Airlines" },
  { code: "IE", name: "Solomon Airlines" },
  { code: "IF", name: "Islas Airways" },
  { code: "IG", name: "Meridiana" },
  { code: "II", name: "LSM International " },
  { code: "IJ", name: "Spring Airlines Japan" },
  { code: "IK", name: "Imair Airlines" },
  { code: "IN", name: "MAT Macedonian Airlines" },
  { code: "IO", name: "Indonesian Airlines" },
  { code: "IP", name: "Island Spirit" },
  { code: "IQ", name: "Augsburg Airways" },
  { code: "IR", name: "Iran Air" },
  { code: "IS", name: "Island Airlines" },
  { code: "IT", name: "Kingfisher Airlines" },
  { code: "IV", name: "Wind Jet" },
  { code: "IW", name: "Wings Air" },
  { code: "IX", name: "Air India Express" },
  { code: "IY", name: "Yemenia" },
  { code: "IZ", name: "Arkia Israel Airlines" },
  { code: "J1", name: "OneJet" },
  { code: "J2", name: "Azerbaijan Airlines" },
  { code: "J3", name: "Northwestern Air" },
  { code: "J4", name: "ALAK" },
  { code: "J5", name: "Alaska Seaplane Service" },
  { code: "J7", name: "Denim Air " },
  { code: "J8", name: "Berjaya Air" },
  { code: "J9", name: "Jazeera Airways" },
  { code: "JA", name: "Air Bosna" },
  { code: "JB", name: "Helijet" },
  { code: "JC", name: "JAL Express" },
  { code: "JD", name: "Japan Air System" },
  { code: "JE", name: "Mango" },
  { code: "JF", name: "Jetairfly" },
  { code: "JG", name: "Jetgo Australia" },
  { code: "JH", name: "Fuji Dream Airlines" },
  { code: "JI", name: "Midway Airlines" },
  { code: "JJ", name: "TAM Brazilian Airlines" },
  { code: "JK", name: "Spanair" },
  { code: "JL", name: "Japan Airlines" },
  { code: "JM", name: "Air Jamaica" },
  { code: "JN", name: "Excel Airways" },
  { code: "JO", name: "JALways" },
  { code: "JP", name: "Adria Airways" },
  { code: "JQ", name: "Jetstar Airways" },
  { code: "JR", name: "Joy Air" },
  { code: "JS", name: "Air Koryo" },
  { code: "JT", name: "Lion Mentari Airlines" },
  { code: "JU", name: "Air Serbia" },
  { code: "JV", name: "Bearskin Lake Air Service" },
  { code: "JW", name: "Arrow Air" },
  { code: "JX", name: "Jusur airways" },
  { code: "JY", name: "Aereonautica militare" },
  { code: "JZ", name: "Skyways Express" },
  { code: "K1", name: "Kostromskie avialinii" },
  { code: "K2", name: "Eurolot" },
  { code: "K5", name: "SeaPort Airlines" },
  { code: "K6", name: "Cambodia Angkor Air (K6)" },
  { code: "K7", name: "KoralBlue Airlines" },
  { code: "K8", name: "Zambia Skyways" },
  { code: "KA", name: "Dragonair" },
  { code: "KB", name: "Druk Air" },
  { code: "KC", name: "Air Astana" },
  { code: "KD", name: "KD Avia" },
  { code: "KE", name: "Korean Air" },
  { code: "KF", name: "Blue1" },
  { code: "KG", name: "Royal Airways" },
  { code: "KH", name: "Kharkiv Airlines" },
  { code: "KI", name: "Adam Air" },
  { code: "KJ", name: "British Mediterranean Airways" },
  { code: "KK", name: "Atlasjet" },
  { code: "KL", name: "KLM Royal Dutch Airlines" },
  { code: "KM", name: "Air Malta" },
  { code: "KN", name: "China United" },
  { code: "KO", name: "Alaska Central Express" },
  { code: "KP", name: "Dense Airways" },
  { code: "KQ", name: "Kenya Airways" },
  { code: "KR", name: "Comores Airlines" },
  { code: "KS", name: "Peninsula Airways" },
  { code: "KT", name: "VickJet" },
  { code: "KU", name: "Kuwait Airways" },
  { code: "KV", name: "Kavminvodyavia" },
  { code: "KW", name: "Carnival Air Lines" },
  { code: "KX", name: "Cayman Airways" },
  { code: "KY", name: "KSY" },
  { code: "KZ", name: "Dense Connection" },
  { code: "L1", name: "All Argentina" },
  { code: "L3", name: "LTU Austria" },
  { code: "L4", name: "Luchsh Airlines " },
  { code: "L5", name: "Lufttransport" },
  { code: "L6", name: "Mauritania Airlines International" },
  { code: "L7", name: "Lugansk Airlines" },
  { code: "L8", name: "Line Blue" },
  { code: "L9", name: "All Asia" },
  { code: "LA", name: "LAN Airlines" },
  { code: "LB", name: "Air Costa" },
  { code: "LC", name: "Varig Log" },
  { code: "LE", name: "Liberty Airways" },
  { code: "LF", name: "FlyNordic" },
  { code: "LG", name: "Luxair" },
  { code: "LH", name: "Lufthansa" },
  { code: "LI", name: "Leeward Islands Air Transport" },
  { code: "LJ", name: "Jin Air" },
  { code: "LK", name: "Air Luxor" },
  { code: "LM", name: "Linhas A" },
  { code: "LN", name: "Libyan Arab Airlines" },
  { code: "LO", name: "LOT Polish Airlines" },
  { code: "LP", name: "LAN Peru" },
  { code: "LQ", name: "LCM AIRLINES" },
  { code: "LR", name: "LACSA" },
  { code: "LS", name: "Jet2.com" },
  { code: "LT", name: "Air Lituanica" },
  { code: "LU", name: "LAN Express" },
  { code: "LV", name: "Albanian Airlines" },
  { code: "LW", name: "Pacific Wings" },
  { code: "LX", name: "Swiss International Air Lines" },
  { code: "LY", name: "El Al Israel Airlines" },
  { code: "LZ", name: "Balkan Bulgarian Airlines" },
  { code: "M1", name: "Maryland Air" },
  { code: "M2", name: "MHS Aviation GmbH" },
  { code: "M3", name: "ABSA - Aerolinhas Brasileiras" },
  { code: "M4", name: "Marysya Airlines" },
  { code: "M5", name: "Kenmore Air" },
  { code: "M7", name: "MasAir" },
  { code: "M8", name: "TransNusa Air" },
  { code: "M9", name: "Motor Sich" },
  { code: "MA", name: "Malév" },
  { code: "MB", name: "MNG Airlines" },
  { code: "MD", name: "Air Madagascar" },
  { code: "ME", name: "Middle East Airlines" },
  { code: "MF", name: "Xiamen Airlines" },
  { code: "MH", name: "Malaysia Airlines" },
  { code: "MI", name: "SilkAir" },
  { code: "MK", name: "Air Mauritius" },
  { code: "ML", name: "Maldivo Airlines" },
  { code: "MM", name: "Peach Aviation" },
  { code: "MN", name: "Comair" },
  { code: "MO", name: "Abu Dhabi Amiri Flight" },
  { code: "MP", name: "Martinair" },
  { code: "MQ", name: "American Eagle Airlines" },
  { code: "MR", name: "Homer Air" },
  { code: "MS", name: "Egyptair" },
  { code: "MT", name: "Thomas Cook Airlines" },
  { code: "MU", name: "China Eastern Airlines" },
  { code: "MW", name: "Maya Island Air" },
  { code: "MX", name: "Breeze Airways" },
  { code: "MY", name: "Midwest Airlines (Egypt)" },
  { code: "MZ", name: "Merpati Nusantara Airlines" },
  { code: "N0", name: "Norte Lineas Aereas" },
  { code: "N3", name: "Volaris El Salvador" },
  { code: "N4", name: "Regionalia México" },
  { code: "N5", name: "Skagway Air Service" },
  { code: "N7", name: "All Spain" },
  { code: "N8", name: "National Air Cargo" },
  { code: "N9", name: "All Europe" },
  { code: "NA", name: "Al-Naser Airlines" },
  { code: "NB", name: "Sterling Airlines" },
  { code: "NC", name: "National Jet Systems" },
  { code: "NE", name: "SkyEurope" },
  { code: "NF", name: "Air Vanuatu" },
  { code: "NG", name: "Lauda Air" },
  { code: "NH", name: "All Nippon Airways" },
  { code: "NI", name: "Portugalia" },
  { code: "NJ", name: "Nordic Global Airlines" },
  { code: "NK", name: "Spirit Airlines" },
  { code: "NL", name: "Shaheen Air International" },
  { code: "NM", name: "Air Madrid" },
  { code: "NN", name: "VIM Airlines" },
  { code: "NP", name: "Nile Air" },
  { code: "NQ", name: "Air Japan" },
  { code: "NR", name: "Jettor Airlines" },
  { code: "NS", name: "Caucasus Airlines" },
  { code: "NT", name: "Binter Canarias" },
  { code: "NU", name: "Japan Transocean Air" },
  { code: "NW", name: "Northwest Airlines" },
  { code: "NX", name: "Air Macau" },
  { code: "NY", name: "Air Iceland" },
  { code: "NZ", name: "Air New Zealand" },
  { code: "O1", name: "Orbit Airlines Azerbaijan" },
  { code: "O2", name: "Oceanic Airlines" },
  { code: "O6", name: "Oceanair" },
  { code: "O7", name: "Ozjet Airlines" },
  { code: "O8", name: "Oasis Hong Kong Airlines" },
  { code: "OA", name: "Olympic Airlines" },
  { code: "OB", name: "Astrakhan Airlines" },
  { code: "OC", name: "Catovair" },
  { code: "OD", name: "Malindo Air" },
  { code: "OF", name: "Air Finland" },
  { code: "OG", name: "AirOnix" },
  { code: "OH", name: "Comair" },
  { code: "OI", name: "Orchid Airlines" },
  { code: "OJ", name: "Overland Airways" },
  { code: "OK", name: "Czech Airlines" },
  { code: "OL", name: "Ostfriesische Lufttransport" },
  { code: "OM", name: "MIAT Mongolian Airlines" },
  { code: "ON", name: "Nauru Air Corporation" },
  { code: "OO", name: "SkyWest" },
  { code: "OP", name: "Air Pegasus" },
  { code: "OQ", name: "Chongqing Airlines" },
  { code: "OR", name: "Arkefly" },
  { code: "OS", name: "Austrian Airlines" },
  { code: "OT", name: "Aeropelican Air Services" },
  { code: "OU", name: "Croatia Airlines" },
  { code: "OV", name: "Estonian Air" },
  { code: "OX", name: "Orient Thai Airlines" },
  { code: "OY", name: "Omni Air International" },
  { code: "OZ", name: "Asiana Airlines" },
  { code: "P0", name: "Proflight Commuter Services" },
  { code: "P4", name: "Patriot Airways" },
  { code: "P5", name: "AeroRep" },
  { code: "P7", name: "Regional Paraguaya" },
  { code: "P8", name: "Air Mekong" },
  { code: "P9", name: "Peruvian Airlines" },
  { code: "PA", name: "Parmiss Airlines (IPV)" },
  { code: "PC", name: "Pegasus Airlines" },
  { code: "PD", name: "Porter Airlines" },
  { code: "PE", name: "Air Europe" },
  { code: "PF", name: "Primera Air" },
  { code: "PG", name: "Bangkok Airways" },
  { code: "PH", name: "Polynesian Airlines" },
  { code: "PI", name: "Piedmont Airlines (1948-1989)" },
  { code: "PJ", name: "Air Saint Pierre" },
  { code: "PK", name: "Pakistan International Airlines" },
  { code: "PL", name: "Aeroper" },
  { code: "PM", name: "Tropic Air" },
  { code: "PN", name: "West Air China" },
  { code: "PO", name: "FlyPortugal" },
  { code: "PP", name: "Air Indus" },
  { code: "PQ", name: "LSM Airlines" },
  { code: "PR", name: "Philippine Airlines" },
  { code: "PS", name: "Ukraine International Airlines" },
  { code: "PT", name: "Red Jet Andes" },
  { code: "PU", name: "PLUNA" },
  { code: "PV", name: "PAN Air" },
  { code: "PW", name: "Precision Air" },
  { code: "PX", name: "Air Niugini" },
  { code: "PY", name: "Surinam Airways" },
  { code: "PZ", name: "TAM Mercosur" },
  { code: "Q2", name: "Maldivian" },
  { code: "Q3", name: "SOCHI AIR CHATER" },
  { code: "Q4", name: "SOCHI AIR EXPRESS" },
  { code: "Q5", name: "40-Mile Air" },
  { code: "Q6", name: "Aero Condor Peru" },
  { code: "Q7", name: "SkyBahamas Airlines" },
  { code: "Q8", name: "Pacific East Asia Cargo Airlines" },
  { code: "Q9", name: "Arik Niger" },
  { code: "QA", name: "Click (Mexicana)" },
  { code: "QB", name: "Georgian National Airlines" },
  { code: "QC", name: "Camair-co" },
  { code: "QD", name: "Dobrolet" },
  { code: "QF", name: "Qantas" },
  { code: "QG", name: "Citilink Indonesia" },
  { code: "QH", name: "Air Florida" },
  { code: "QI", name: "Cimber Air" },
  { code: "QJ", name: "Jet Airways" },
  { code: "QK", name: "Air Canada Jazz" },
  { code: "QL", name: "Aero Lanka" },
  { code: "QM", name: "Air Malawi" },
  { code: "QO", name: "Origin Pacific Airways" },
  { code: "QP", name: "Air Kenya (Priv)" },
  { code: "QQ", name: "Alliance Airlines" },
  { code: "QR", name: "Qatar Airways" },
  { code: "QS", name: "Travel Service" },
  { code: "QT", name: "TAMPA" },
  { code: "QU", name: "East African" },
  { code: "QV", name: "Lao Airlines" },
  { code: "QW", name: "Blue Wings" },
  { code: "QX", name: "Horizon Air" },
  { code: "QY", name: "Red Jet Canada" },
  { code: "QZ", name: "Indonesia AirAsia" },
  { code: "R2", name: "Orenburg Airlines" },
  { code: "R3", name: "Aircompany Yakutia" },
  { code: "R4", name: "Rossiya" },
  { code: "R5", name: "Malta Air Charter" },
  { code: "R6", name: "RACSA" },
  { code: "R7", name: "Aserca Airlines" },
  { code: "R8", name: "AirRussia" },
  { code: "RA", name: "Nepal Airlines" },
  { code: "RB", name: "Syrian Arab Airlines" },
  { code: "RC", name: "Atlantic Airways" },
  { code: "RD", name: "Ryan International Airlines" },
  { code: "RE", name: "Aer Arann" },
  { code: "RF", name: "Florida West International Airways" },
  { code: "RG", name: "VRG Linhas Aereas" },
  { code: "RI", name: "Mandala Airlines" },
  { code: "RJ", name: "Royal Jordanian" },
  { code: "RK", name: "Air Afrique" },
  { code: "RL", name: "Royal Falcon" },
  { code: "RM", name: "Rainbow Air US" },
  { code: "RN", name: "Rainbow Air (RAI)" },
  { code: "RO", name: "Tarom" },
  { code: "RP", name: "Chautauqua Airlines" },
  { code: "RQ", name: "Kam Air" },
  { code: "RR", name: "REXAIR VIRTUEL" },
  { code: "RS", name: "Sky Regional" },
  { code: "RT", name: "Real Tonga" },
  { code: "RU", name: "Rainbow Air Euro" },
  { code: "RV", name: "Caspian Airlines" },
  { code: "RW", name: "Republic Airlines" },
  { code: "RY", name: "Rainbow Air Canada" },
  { code: "RZ", name: "Euro Exec Express" },
  { code: "S0", name: "Spike Airlines" },
  { code: "S1", name: "Serbian Airlines" },
  { code: "S2", name: "Air Sahara" },
  { code: "S3", name: "Santa Barbara Airlines" },
  { code: "S4", name: "SATA International" },
  { code: "S5", name: "Shuttle America" },
  { code: "S6", name: "Salmon Air" },
  { code: "S7", name: "S7 Airlines" },
  { code: "S8", name: "Snowbird Airlines" },
  { code: "S9", name: "Starbow Airlines" },
  { code: "SA", name: "South African Airways" },
  { code: "SB", name: "Air Caledonie International" },
  { code: "SC", name: "Shandong Airlines" },
  { code: "SD", name: "Sudan Airways" },
  { code: "SE", name: "XL Airways France" },
  { code: "SG", name: "Spicejet" },
  { code: "SH", name: "Sharp Airlines" },
  { code: "SI", name: "Skynet Airlines" },
  { code: "SJ", name: "Sriwijaya Air" },
  { code: "SK", name: "Scandinavian Airlines System" },
  { code: "SL", name: "Thai Lion Air" },
  { code: "SM", name: "Spirit of Manila Airlines" },
  { code: "SN", name: "Brussels Airlines" },
  { code: "SO", name: "Salsa d'Haiti" },
  { code: "SP", name: "SATA Air Acores" },
  { code: "SQ", name: "Singapore Airlines" },
  { code: "SS", name: "Corsairfly" },
  { code: "ST", name: "Germania" },
  { code: "SU", name: "Aeroflot Russian Airlines" },
  { code: "SV", name: "Saudi Arabian Airlines" },
  { code: "SW", name: "Air Namibia" },
  { code: "SX", name: "SkyWork Airlines " },
  { code: "SY", name: "Sun Country Airlines" },
  { code: "SZ", name: "Salzburg arrows" },
  { code: "T0", name: "TACA Peru" },
  { code: "T2", name: "Thai Air Cargo" },
  { code: "T3", name: "Eastern Airways" },
  { code: "T4", name: "Hellas Jet" },
  { code: "T5", name: "Turkmenistan Airlines" },
  { code: "T6", name: "Trans Pas Air" },
  { code: "T7", name: "Twin Jet" },
  { code: "TA", name: "Grupo TACA" },
  { code: "TB", name: "TrasBrasil" },
  { code: "TC", name: "Air Tanzania" },
  { code: "TD", name: "Atlantis European Airways" },
  { code: "TE", name: "FlyLal" },
  { code: "TG", name: "Thai Airways International" },
  { code: "TH", name: "TransBrasil Airlines" },
  { code: "TI", name: "TransHolding" },
  { code: "TJ", name: "T.J. Air" },
  { code: "TK", name: "Turkish Airlines" },
  { code: "TL", name: "Airnorth" },
  { code: "TM", name: "Air Mozambique" },
  { code: "TN", name: "Air Tahiti Nui" },
  { code: "TO", name: "Transavia France" },
  { code: "TP", name: "TAP Portugal" },
  { code: "TQ", name: "Texas Wings" },
  { code: "TS", name: "Air Transat" },
  { code: "TT", name: "Tiger Airways Australia" },
  { code: "TU", name: "Tunisair" },
  { code: "TV", name: "Virgin Express" },
  { code: "TW", name: "Trinity Airways" },
  { code: "TX", name: "Air Caraïbes" },
  { code: "TY", name: "Iberworld" },
  { code: "TZ", name: "Scoot" },
  { code: "U1", name: "Aviabus" },
  { code: "U2", name: "easyJet" },
  { code: "U3", name: "Avies" },
  { code: "U4", name: "PMTair" },
  { code: "U5", name: "USA3000 Airlines" },
  { code: "U6", name: "Ural Airlines" },
  { code: "U7", name: "Northern Dene Airways" },
  { code: "U8", name: "Armavia" },
  { code: "U9", name: "Tatarstan Airlines" },
  { code: "UA", name: "United Airlines" },
  { code: "UB", name: "Myanma Airways" },
  { code: "UD", name: "Hex'Air" },
  { code: "UE", name: "Nasair" },
  { code: "UF", name: "UM Airlines" },
  { code: "UG", name: "Tuninter" },
  { code: "UH", name: "US Helicopter Corporation" },
  { code: "UI", name: "Eurocypria Airlines" },
  { code: "UJ", name: "AlMasria Universal Airlines" },
  { code: "UK", name: "Air Vistara" },
  { code: "UL", name: "SriLankan Airlines" },
  { code: "UM", name: "Air Zimbabwe" },
  { code: "UN", name: "Transaero Airlines" },
  { code: "UO", name: "Hong Kong Express Airways" },
  { code: "UP", name: "Bahamasair" },
  { code: "UR", name: "UTair-Express" },
  { code: "US", name: "US Airways" },
  { code: "UT", name: "UTair Aviation" },
  { code: "UU", name: "Air Austral" },
  { code: "UW", name: "UVT Aero" },
  { code: "UX", name: "Air Europa" },
  { code: "UZ", name: "El-Buraq Air Transport" },
  { code: "V0", name: "Conviasa" },
  { code: "V1", name: "VIA Líneas Aéreas" },
  { code: "V2", name: "Vision Airlines (V2)" },
  { code: "V3", name: "Carpatair" },
  { code: "V5", name: "Danube Wings (V5)" },
  { code: "V6", name: "VIP Ecuador" },
  { code: "V7", name: "VOLOTEA Airways" },
  { code: "V8", name: "ATRAN Cargo Airlines" },
  { code: "V9", name: "Star1 Airlines" },
  { code: "VA", name: "Virgin Australia" },
  { code: "VC", name: "Strategic Airlines" },
  { code: "VD", name: "Air Libert" },
  { code: "VE", name: "Volare Airlines" },
  { code: "VF", name: "Valuair" },
  { code: "VG", name: "VLM Airlines" },
  { code: "VH", name: "Virgin Pacific" },
  { code: "VI", name: "Volga-Dnepr Airlines" },
  { code: "VJ", name: "VietJet Air" },
  { code: "VK", name: "Virgin Nigeria Airways" },
  { code: "VL", name: "Air VIA" },
  { code: "VN", name: "Vietnam Airlines" },
  { code: "VO", name: "Tyrolean Airways" },
  { code: "VP", name: "VASP" },
  { code: "VQ", name: "Viking Hellas" },
  { code: "VR", name: "TACV" },
  { code: "VS", name: "Virgin Atlantic Airways" },
  { code: "VT", name: "Air Tahiti" },
  { code: "VU", name: "Air Ivoire" },
  { code: "VV", name: "Aerosvit Airlines" },
  { code: "VW", name: "Aeromar" },
  { code: "VX", name: "Virgin America" },
  { code: "VY", name: "Vueling Airlines" },
  { code: "VZ", name: "MyTravel Airways" },
  { code: "W1", name: "World Experience Airline" },
  { code: "W2", name: "Maastricht Airlines" },
  { code: "W3", name: "World Scale Airlines" },
  { code: "W4", name: "AeroWorld " },
  { code: "W5", name: "Mahan Air" },
  { code: "W6", name: "Wizz Air" },
  { code: "W7", name: "Austral Brasil" },
  { code: "W9", name: "Air Bagan" },
  { code: "WA", name: "KLM Cityhopper" },
  { code: "WB", name: "Rwandair Express" },
  { code: "WC", name: "Islena De Inversiones" },
  { code: "WD", name: "Amsterdam Airlines" },
  { code: "WE", name: "Thai Smile Airways" },
  { code: "WF", name: "Widerøe" },
  { code: "WG", name: "Sunwing" },
  { code: "WH", name: "China Northwest Airlines (WH)" },
  { code: "WJ", name: "WebJet Linhas A" },
  { code: "WK", name: "Edelweiss Air" },
  { code: "WM", name: "Windward Islands Airways" },
  { code: "WN", name: "Southwest Airlines" },
  { code: "WO", name: "World Airways" },
  { code: "WP", name: "Island Air (WP)" },
  { code: "WQ", name: "PanAm World Airways" },
  { code: "WR", name: "WestJet Encore" },
  { code: "WS", name: "WestJet" },
  { code: "WU", name: "Wizz Air Ukraine" },
  { code: "WV", name: "Swe Fly" },
  { code: "WW", name: "bmibaby" },
  { code: "WX", name: "CityJet" },
  { code: "WY", name: "Oman Air" },
  { code: "WZ", name: "Red Wings" },
  { code: "X3", name: "TUIfly" },
  { code: "X5", name: "Fly Romania" },
  { code: "XA", name: "XAIR USA" },
  { code: "XB", name: "NEXT Brasil" },
  { code: "XE", name: "ExpressJet" },
  { code: "XF", name: "Vladivostok Air" },
  { code: "XG", name: "Calima Aviacion" },
  { code: "XJ", name: "Mesaba Airlines" },
  { code: "XK", name: "Corse-Mediterranee" },
  { code: "XL", name: "Aerolane" },
  { code: "XM", name: "Alitalia Express" },
  { code: "XN", name: "Xpressair" },
  { code: "XO", name: "LTE International Airways" },
  { code: "XP", name: "XPTO" },
  { code: "XQ", name: "SunExpress" },
  { code: "XR", name: "Skywest Australia" },
  { code: "XV", name: "BVI Airways" },
  { code: "XW", name: "Sky Express" },
  { code: "XX", name: "Greenfly" },
  { code: "XY", name: "Nas Air" },
  { code: "XZ", name: "Congo Express" },
  { code: "Y1", name: "Yellowstone Club Private Shuttle" },
  { code: "Y4", name: "Volaris" },
  { code: "Y5", name: "Asia Wings" },
  { code: "Y7", name: "NordStar Airlines" },
  { code: "Y8", name: "Marusya Airways" },
  { code: "Y9", name: "Kish Air" },
  { code: "YC", name: "Ciel Canadien" },
  { code: "YD", name: "Gomelavia" },
  { code: "YE", name: "Yellowtail" },
  { code: "YH", name: "Yangon Airways Ltd." },
  { code: "YK", name: "Cyprus Turkish Airlines" },
  { code: "YL", name: "Yamal Airlines" },
  { code: "YM", name: "Montenegro Airlines" },
  { code: "YO", name: "TransHolding System" },
  { code: "YQ", name: "Polet Airlines (Priv)" },
  { code: "YR", name: "SENIC AIRLINES" },
  { code: "YS", name: "Régional" },
  { code: "YT", name: "Yeti Airways" },
  { code: "YV", name: "Mesa Airlines" },
  { code: "YW", name: "Air Nostrum" },
  { code: "YX", name: "Midwest Airlines" },
  { code: "YY", name: "Virginwings" },
  { code: "YZ", name: "LSM AIRLINES " },
  { code: "Z0", name: "All Argentina Express" },
  { code: "Z2", name: "Zest Air" },
  { code: "Z3", name: "Avient Aviation" },
  { code: "Z4", name: "Zoom Airlines" },
  { code: "Z5", name: "INAVIA Internacional" },
  { code: "Z6", name: "ZABAIKAL AIRLINES" },
  { code: "Z7", name: "REDjet" },
  { code: "Z8", name: "Amaszonas" },
  { code: "Z9", name: "Flightlink Tanzania" },
  { code: "ZC", name: "Korongo Airlines" },
  { code: "ZE", name: "Eastar Jet" },
  { code: "ZF", name: "Athens Airways" },
  { code: "ZG", name: "Viva Macau" },
  { code: "ZH", name: "Shenzhen Airlines" },
  { code: "ZI", name: "Aigle Azur" },
  { code: "ZJ", name: "Zambezi Airlines (ZMA)" },
  { code: "ZK", name: "Great Lakes Airlines" },
  { code: "ZL", name: "Regional Express" },
  { code: "ZM", name: "Apache Air" },
  { code: "ZN", name: "Zenith International Airline" },
  { code: "ZP", name: "Zabaykalskii Airlines" },
  { code: "ZQ", name: "Locair" },
  { code: "ZS", name: "Sama Airlines" },
  { code: "ZT", name: "Tomp Airlines" },
  { code: "ZV", name: "V Air" },
  { code: "ZW", name: "Air Wisconsin" },
  { code: "ZX", name: "Japan Regio" },
  { code: "ZY", name: "Ada Air" },
];

/**
 * Most-booked carriers (by bookings since 2025), highest first. Shown as the
 * default AirlineSelect list before the user searches, so the common airlines
 * are one tap away instead of buried in the ~961-carrier alphabetical list.
 * Codes not present in IATA_AIRLINES are skipped safely at render time.
 */
export const POPULAR_AIRLINE_CODES: string[] = [
  "AA", "DL", "UA", "F9", "AS", "B6", "AC", "BA", "LH", "HA",
  "TK", "QR", "EK", "AF", "AV", "CX", "CM", "EY", "KL", "AI",
  "FI", "KE", "6E", "BR", "SY", "TP", "AM", "EI", "WN", "IB",
  "VS", "MX", "JL", "LX", "SK", "Y4", "CI", "NH", "OZ", "WS",
  "SQ", "AZ", "LA", "PR", "VY", "U2", "A3", "AY", "FD", "VJ",
];
